import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../State/Global/AppContext";
import { api } from "../../Requests/Api";
import { PlusOutlined } from "@ant-design/icons";
import { Tag, Modal, Select, Button, Input, Spin, message, Divider } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
const { Option } = Select;
function ChatTags({ convTags, convTagGroups, loadTagsCb, editConvTagsCb }) {
    const { t } = useTranslation();
    const { appState } = useAppContext();
    const selectedChatId = useMemo(() => {
        return appState.selectedChat.id;
    }, [appState.selectedChat.id]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [tags, setTags] = useState([]);
    const [selectedTag, setSelectedTag] = useState([]);
    const [isModalLoading, setIsModalLoading] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [groupsInUse, setGroupsInUse] = useState([]);
    const [groups, setGroups] = useState([]);
    const titleStyles = {
        margin: 0,
        color: "#35209E",
        fontWeight: "bold",
    };
    function handleSelect(tag) {
        setSelectedTag(tag.key);
        addTag(tag.key);
    }

    function handleDeselect(tag) {
        handleTagDelete([parseInt(tag.key)]);
    }

    function openTagModal() {
        setIsModalVisible(true);
    }
    function handleCancel() {
        setIsModalVisible(false);
    }
    function handleChange(tagList) {
        setSelectedTag(tagList);
    }
    function handleTagDelete(listTagsIds) {
        listTagsIds.map((id) =>
            api
                .tags()
                .deleteTagFromConversation(selectedChatId, id)
                .then()
                .catch((err) => console.log(err))
        );
        const editedConvTags = convTags?.filter(
            (tag) => listTagsIds.indexOf(tag.conversationLabel.id) < 0
        );
        editConvTagsCb(editedConvTags);
    }
    function loadTags() {
        api.tags()
            .list()
            .then((res) => {
                setTags(res.data.conversationLabels);
            });
    }
    function addTag(tagIdStr) {
        const tagId = parseInt(tagIdStr, 10);
        if (selectedChatId && tagId) {
            setIsModalLoading(true);
            const newTag = {
                chatId: selectedChatId,
                conversationLabelId: tagId,
                labeler: "ASSISTANT",
            };
            api.tags()
                .addTagToConversation(newTag)
                .then((res) => {
                    setSelectedTag(null);
                    const newConvTags = [...convTags];
                    const newT = tags.filter((t) => t && t.id === tagId)[0];
                    newConvTags.push({ conversationLabel: newT });
                    editConvTagsCb(newConvTags);
                    setIsModalLoading(false);
                })
                .catch((err) => {
                    if (err.response?.data?.error?.key === "CONVERSATION_ALREADY_LABELED") {
                        message.warning(t("labels.conversationLabelAlredyExist"));
                    } else {
                        message.error(t("labels.conversationLabelCreatedError"));
                    }
                    setIsModalLoading(false);
                });
        }
    }

    async function handleAddGroupClick() {
        if (!selectedGroup) {
            return;
        }
        const group = groups.find((g) => g.name === selectedGroup.value);
        if (!groupsInUse.map((g) => g.id).includes(selectedGroup.id)) {
            const res = await api.tagsGroups().get(group.id);
            const newGroup = res.data;
            setGroupsInUse([...groupsInUse, newGroup]);
            setSelectedGroup(null);
        }
    }

    async function resetState() {
        setGroups([]);
        setGroupsInUse([]);
    }

    function handleModalGroupClose() {
        resetState().then(() => {
            setIsModalVisible(false);
        });
    }

    async function removeGroup(groupId) {
        const group = groupsInUse.find((g) => g.id === parseInt(groupId));
        const idsTagsToRemove = group.conversationLabels.map((tag) => tag.id);
        handleTagDelete(idsTagsToRemove);
        setGroupsInUse(groupsInUse.filter((g) => g.id !== groupId));
    }

    useEffect(() => {
        async function buildSelectedGroups() {
            if (convTagGroups && convTagGroups.length) {
                try {
                    const usedGroupsIds = new Set();
                    const tagsInUse = convTags.map((t) => t.conversationLabel);
                    tagsInUse.map((t) => t.groupId && usedGroupsIds.add(t.groupId));

                    const usedGroups = [];
                    for (const groupId of usedGroupsIds) {
                        const res = await api.tagsGroups().get(groupId);
                        const group = res.data;
                        usedGroups.push(group);
                    }

                    const res = await api.tagsGroups().list();
                    const groups = res.data.conversationLabelGroups;

                    setGroups(groups);
                    setGroupsInUse(usedGroups);
                } catch (err) {
                    message.error(err);
                }
            }
        }
        buildSelectedGroups();
    }, [convTagGroups, isModalVisible]);

    useEffect(() => {
        if (selectedChatId) {
            loadTags();
        }
    }, [selectedChatId]);
    useEffect(() => {
        setSelectedTag(null);
    }, []);
    return (
        <>
            <div style={{ maxWidth: "230px", textOverflow: "ellipsis", overflow: "hidden" }}>
                {convTags && convTags.length ? (
                    convTags?.map((tag) => (
                        <Tag
                            key={tag.conversationLabel.id}
                            style={{ cursor: "pointer" }}
                            onClick={() => setIsModalVisible(true)}
                        >
                            {tag.conversationLabel.value}
                        </Tag>
                    ))
                ) : (
                    <Tag
                        style={{
                            borderStyle: "dashed",
                            cursor: "pointer",
                            background: "none",
                            userSelect: "none",
                        }}
                        onClick={openTagModal}
                    >
                        <PlusOutlined /> {t("labels.addLabels")}
                    </Tag>
                )}
            </div>
            <Modal
                onCancel={handleModalGroupClose}
                visible={isModalVisible && convTagGroups && convTagGroups.length}
                title={t("labels.modalTitle")}
                footer={
                    <>
                        <Button onClick={handleModalGroupClose}>{t("close")}</Button>
                    </>
                }
            >
                <h3>{t("labels.addGroup")}</h3>
                <Select
                    labelInValue
                    style={{ maxWidth: "100%" }}
                    placeholder={t("labels.selectAGroup")}
                    value={selectedGroup ? selectedGroup : []}
                    onSelect={(value) => setSelectedGroup(value)}
                    showSearch={true}
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {groups
                        .filter((group) => !groupsInUse.map((g) => g.id).includes(group.id))
                        .map((group) => (
                            <Option key={group.id} value={group.name}>
                                {group.name}
                            </Option>
                        ))}
                </Select>
                <Button onClick={handleAddGroupClick}>{t("labels.add")}</Button>
                <Divider />

                {groupsInUse.map((group) => {
                    const tagsInUse = group.conversationLabels.filter((t) =>
                        convTags?.map((tag) => tag.conversationLabel.id).includes(t.id)
                    );
                    const tagsOfGroup = group.conversationLabels;
                    return (
                        <div
                            key={`group:${group.id}`}
                            style={{ maxWidth: "100%", maxHeight: "120px", overflow: "auto" }}
                        >
                            <div style={{ display: "flex" }}>
                                <h3>{group.name}</h3>
                                <Button
                                    onClick={() => {
                                        removeGroup(group.id);
                                    }}
                                    style={{ marginLeft: "auto", marginRight: 0 }}
                                    className={"opt-app__button"}
                                >
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </Button>
                            </div>
                            <Select
                                mode="multiple"
                                labelInValue
                                style={{ width: "100%" }}
                                defaultValue={tagsInUse.map((t) => ({
                                    key: t.id,
                                    value: t.id,
                                    label: t.value,
                                }))}
                                onSelect={handleSelect}
                                onDeselect={handleDeselect}
                                showSearch={true}
                                filterOption={(input, option) =>
                                    option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {tagsOfGroup.map((tag) => (
                                    <Option key={tag.id} value={tag.id}>
                                        {tag.value}
                                    </Option>
                                ))}
                            </Select>
                            <Divider />
                        </div>
                    );
                })}
            </Modal>

            <Modal
                onCancel={() => setIsModalVisible(false)}
                visible={isModalVisible && !(convTagGroups && convTagGroups.length)}
                title={t("labels.modalTitle")}
                footer={<Button onClick={handleCancel}>{t("close")}</Button>}
            >
                <Spin spinning={isModalLoading}>
                    <div style={{ marginBottom: "15px" }}>
                        <p style={titleStyles}>{t("labels.add")}</p>
                        <Input.Group compact style={{ display: "flex" }}>
                            <Select
                                value={selectedTag}
                                style={{ width: "100%", marginRight: "5px" }}
                                placeholder={t("labels.selectLabel")}
                                onChange={handleChange}
                                showSearch={true}
                                filterOption={(input, option) =>
                                    option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {tags.map((tag) => (
                                    <Select.Option key={tag.id} value={tag.id} label={tag.value}>
                                        {tag.value}
                                    </Select.Option>
                                ))}
                            </Select>
                            <Button onClick={() => addTag(selectedTag)}>{t("labels.add")}</Button>
                        </Input.Group>
                    </div>
                    <p style={titleStyles}>{t("labels.conversationTags")}</p>
                    {convTags && convTags.length ? (
                        convTags?.map((tag) => (
                            <Tag
                                key={tag.conversationLabel.id}
                                closable
                                onClose={() => handleTagDelete([tag.conversationLabel.id])}
                            >
                                {tag.conversationLabel.value}
                            </Tag>
                        ))
                    ) : (
                        <Tag
                            style={{
                                borderStyle: "dashed",
                                cursor: "pointer",
                                background: "none",
                                userSelect: "none",
                            }}
                        >
                            {t("labels.noLabels")}
                        </Tag>
                    )}
                </Spin>
            </Modal>
        </>
    );
}
export default ChatTags;
